import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../../services/api.service';
import {
  Payment,
  PaymentIntentResponse,
  PaymentMetadata,
  PaymentStatusResponse,
  RequestPaymentStatus
} from '../../models/stripe/payment.model';
import { DonationType } from '../../stripe-card-form/payment.constants';

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  constructor(private http: HttpClient,
              private apiService: ApiService) {
  }

  sendPaymentIntent(isUnloggedUser: boolean,
                    token: string,
                    amount: number,
                    donationType: string,
                    metadata: PaymentMetadata): Observable<PaymentIntentResponse> {
    const paymentInfo: Payment = {
      token,
      amount,
      donation_type: donationType,
      metadata
    };

    return isUnloggedUser ?
      this.apiService.postUnloggedPayment(paymentInfo) :
      this.apiService.postLoggedPayment(paymentInfo);
  }

  getPaymentStatus(stripeId: string, donationType: DonationType): Observable<PaymentStatusResponse> {
    const paymentRequest: RequestPaymentStatus = {
      stripe_id: stripeId,
      donation_type: donationType
    };

    return this.apiService.getPaymentStatus(paymentRequest);
  }
}
